
import { Box, IconButton, MenuItem, Tooltip, Typography } from "@mui/material"
import MaterialReactTable from "material-react-table"
import React, { useMemo, useState } from "react"
//Import Material React Table Translations
import { MRT_Localization_ES } from "material-react-table/locales/es"
import { ThemeProvider, darken } from "@mui/material"
import { Edit } from '@mui/icons-material';
import EditableFieldValue from "../EditableFieldValue"

const TablaAvancesEditables = ({ columnas, lineas, titulo, handleOpen, acciones, handleEditableFieldValue }) => {
    const [data, setData] = useState(lineas)
    const columns = useMemo(() => columnas, [data])
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    })

    const columnsEditable = [
        {
          accessorKey: "id",
        },
        {
          header: "Mes",
          accessorKey: "new_mes",
          size: 50,
          minSize: 100,
          maxSize: 200,
          Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
        },
        {
          header: "% de Avance",
          accessorKey: "new_deavance",
          size: 50,
          minSize: 100,
          maxSize: 200,
          // Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
          Cell: ({ cell }) => <EditableFieldValue item={cell.getValue()} celda={cell.row.original} handleEditableFieldValue={handleEditableFieldValue}></EditableFieldValue>,
        },
      ]

    React.useEffect(() => {
        if (lineas.length > 0) {
            setData(lineas)
        } else {
            setData([])
        }
    }, [lineas, columnas])

    const openModal = (row) => {
        var id = row.getValue("id")
        handleOpen(id, lineas)
    }

    return (
        <>
            <ThemeProvider>
                <MaterialReactTable
                    muiTablePaginationProps={{
                        rowsPerPageOptions: [5, 10],
                        showFirstLastPageButtons: false,
                    }}
                    onPaginationChange={setPagination}
                    state={{ pagination }}
                    columns={columnsEditable}
                    data={data}
                    muiTablePaperProps={{
                        sx: (theme) => ({
                            borderRadius: '0.55rem',
                            border: darken(theme.palette.background.default, 0.1),
                            bgcolor: darken(theme.palette.primary.dark, 0.1),
                            maxWidth: '100vw',
                            m: 'auto',
                        }),
                    }}
                    enableFullScreenToggle={false}
                    enableColumnFilterModes={true}
                    enableColumnOrdering={true}
                    enableColumnActions={false}
                    enableColumnFilters={true}
                    enableSorting={true}
                    enableColumnResizing
                    columnResizeMode="onChange"
                    enablePinning
                    enableRowActions={false}
                    enableStickyHeader
                    initialState={{ showColumnFilters: false, columnVisibility: { id: false }, density: "compact" }}
                    positionToolbarAlertBanner="bottom"
                    localization={MRT_Localization_ES}
                    defaultColumn={{
                        maxSize: 400,
                        minSize: 40,
                    }}
                    muiTableContainerProps={{ sx: { maxWidth: "95vw", fontSize: { xs: ".7rem", md: "7rem" } } }}
                    renderRowActions={({ row, table }) => (
                        <Box sx={{ display: 'flex', gap: '1rem' }}>
                            <Tooltip arrow placement="left" title="Editar">
                                <IconButton onClick={() => openModal(row)}>
                                    <Edit />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    )}
                    renderTopToolbarCustomActions={() => (
                        <>
                            <Typography variant="subtitle" p="2px">
                                {titulo}
                            </Typography>
                        </>
                    )}
                />
            </ThemeProvider>
        </>
    )
}

export default React.memo(TablaAvancesEditables)
